import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalComponent from '../../components/ModalComponent';

const CannotChangePlanErrorPage = () => {
  const Navigate = useNavigate();
  const [showIncompletePaymentModal, setShowIncompletePaymentModal] = useState(true);

  const handleIncompletePaymentModal = () => {
    setShowIncompletePaymentModal(!showIncompletePaymentModal);
    Navigate('/my-account/plans');
  };

  return (
    <div>
      <ModalComponent
        title="プランを変更できません"
        body={(
          <div>
            <div>
              変更しようとしているプランよりも多くのページを持っているため、プランを変更することはできません。
            </div>
          </div>
        )}
        centered
        animation={false}
        show={showIncompletePaymentModal}
        onConfirm={handleIncompletePaymentModal}
        closeModal={handleIncompletePaymentModal}
        cancelButtonText="アカウント設定へ"
        hideConfirmButton
      />
    </div>
  );
};

export default CannotChangePlanErrorPage;
